// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"118":"edc3f6f9","957":"5a808aa3"}[chunkId] + ".css";
};